import React, {useEffect, useRef, useState} from 'react';
import { Wheel } from '@boriska420/react-custom-roulette';
import {toast} from "react-toastify";
import axiosInstance from "../../../axios";
import BuyItem from "../../components/BuyItem";
import {useTranslation} from "react-i18next";

const customOrder = {
    'coins': 1,
    'item': 2,
};



const generateColorShades = (firstColor, secondColor, count) => {
    const colors = [];
    const startColor = hexToRgb(firstColor);
    const endColor = hexToRgb(secondColor);

    for (let i = 0; i < count; i++) {
        const r = Math.round(startColor.r + (endColor.r - startColor.r) * (i / (count - 1)));
        const g = Math.round(startColor.g + (endColor.g - startColor.g) * (i / (count - 1)));
        const b = Math.round(startColor.b + (endColor.b - startColor.b) * (i / (count - 1)));
        colors.push(rgbToHex(r, g, b));
    }

    return colors;
};


const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255
    };
};


const rgbToHex = (r, g, b) => {
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};


const SpinWheel = () => {
    const { t } = useTranslation();
    const festiveEventName = "FESTIVE_EVENT_HALLOWEEN_2024"

    const [segments,setSegments] = useState([
        { option: '', style: { backgroundColor: 'orange', textColor: 'white' } },]);

    const [spinItems, setSpinItems] = useState([]);
    const [cases, setCases] = useState([]);

    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [festiveEventMetadata, setFestiveEventMetadata] = useState(null);
    const [userGiveaway, setUserGiveaway] = useState(null);
    const [canClaimGiveaway, setCanClaimGiveaway] = useState(false); // Change to useState
    const [claimedGiveaway, setClaimedGiveaway] = useState(false);
    const [itemToBuy, setItemToBuy] = useState("");
    const [isBuyOpen, setIsBuyOpen] = useState(false);


    const [mappedPrizes, setMappedPrizes] = useState([])


    const nextClaimTime = useRef(null);
    const timeLeft = useRef(0);

    useEffect(() => {
        const loadMetadata = async () => {
            console.log("loadMetadata")
            try {
                const response = await axiosInstance.get(`/festiveEvent/metadata/${festiveEventName}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (response.status === 200 && response.data !== null){
                    setFestiveEventMetadata(response.data);
                }

            } catch (error) {
                console.log(error);
                toast.error(t("Failed to fetch Metadata of festive event."));
            }
        };

        loadMetadata();
    }, []);

    useEffect(() => {
        const loadSpinPrizes = async () => {
            console.log("loadSpinPrizes")
            try {
                const response = await axiosInstance.get(`/uncategory/casePrizes/${festiveEventMetadata["giveaway"]}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (response.data !== null){
                    setSpinItems(response.data.case_prizes.sort((a, b) => b.chance - a.chance ));
                }

            } catch (error) {
                console.log(error);
                toast.error(t("Failed to fetch items."));
            }
        };

        const loadSpinCases = async () => {
            console.log("loadSpinCases")
            try {
                const response = await axiosInstance.get(`/user/inv/${festiveEventMetadata["giveaway"]}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (response.data !== null){
                    setCases(response.data);
                }

            } catch (error) {
                console.log(error);
                toast.error(t("Failed to fetch cases."));
            }
        };

        const loadCanUserClaimGiveaway = async () => {
            console.log("loadCanUserClaimGiveaway")
            try {
                const response = await axiosInstance.post(`/festiveEvent/giveaway`,
                    {
                        "festive_event": festiveEventName
                    }, {headers: {'Content-Type': 'application/json'}
                    });
                if (response.data !== null){
                    setUserGiveaway(response.data);
                    setCanClaimGiveaway(response.data['can_claim']);
                    nextClaimTime.current = new Date(response.data['next_time_claim']);
                    updateTimeLeft()
                }

            } catch (error) {
                console.log(error);
                toast.error(t("Failed to fetch your giveaway info."));
            }
        };

        if(festiveEventMetadata !== null && !isBuyOpen){
            console.log("start")
            setItemToBuy(festiveEventMetadata["giveaway"])
            loadSpinPrizes();
            loadSpinCases();
            loadCanUserClaimGiveaway();
        }
    }, [festiveEventMetadata, claimedGiveaway, isBuyOpen]);


    useEffect(() => {
        const loadItemsData = async () => {
            console.log("loadItemsData")
            try {
                const response = await axiosInstance.post(`/uncategory/items`,
                    {
                        "base_items_id": spinItems
                            .filter(e => e.prize_type === "item")
                            .map(e => Number(e.value))
                    },
                    { headers: { 'Content-Type': 'application/json' } }
                );

                if (response.data !== null) {
                    const mappedData = spinItems.map(e => {
                        e.itemData = response.data.find(i => i.id === Number(e.value));
                        return e;  // Повертаємо об'єкт з доданим полем itemData
                    });

                    const newMappedPrizes = generateColorShades("#f7a605", "#9605f7", spinItems.length).map((color, index) => {
                        mappedData[index].color = color;
                        return mappedData[index];
                    });
                    var reSortedMappedPrizes = []
                    for (let i = 0; i < newMappedPrizes.length; i++) {
                        if(i%2===0){
                            reSortedMappedPrizes.push(newMappedPrizes[i])
                        }else{
                            reSortedMappedPrizes = [newMappedPrizes[i], ...reSortedMappedPrizes]
                        }
                    }

                    setMappedPrizes(reSortedMappedPrizes)
                }
            } catch (error) {
                console.log(error);
                toast.error(t("Failed to fetch items data."));
            }
        };

        if (spinItems.length > 0) {
            loadItemsData();
        }
    }, [spinItems]);

    useEffect(() => {
        if (mappedPrizes && mappedPrizes.length > 0) {
            const newSegments = mappedPrizes.map(e => {
                return {
                    option: '',
                    optionSize: e.chance,
                    style: {
                        backgroundColor: e.color,
                        textColor: "white"
                    }
                };
            });
            setSegments(newSegments);
        }
    }, [mappedPrizes]);

    const updateTimeLeft = () => {
        const now = new Date().getTime();
        const remainingTime = nextClaimTime.current - now;

        if (remainingTime <= 0) {
            setCanClaimGiveaway(true);
            timeLeft.current = 0; // Reset time left
        } else {
            timeLeft.current = remainingTime; // Update time left
        }
    };
    useEffect(() => {
        console.log("timer")
        const timer = setInterval(() => {
            if (nextClaimTime.current) {
                const now = new Date().getTime();
                const remainingTime = nextClaimTime.current - now;

                if (remainingTime <= 0) {
                    clearInterval(timer);
                    setCanClaimGiveaway(true);
                    timeLeft.current = 0; // Reset time left
                } else {
                    timeLeft.current = remainingTime; // Update time left
                }
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatTimeLeft = (ms) => {
        const minutes = Math.floor((ms / (1000 * 60)) % 60);
        const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
        return `${hours}${t("h.")} ${minutes}${t("m.")}`;
    };


    const handleBuyClick = () => {
        setIsBuyOpen(true);
    };
    const handleCloseBuyItem = () => {
        setIsBuyOpen(false);
    };

    const spin = async () => {
        if(cases.length === 0){
            return
        }
        try {
            const response = await axiosInstance.post(`/user/inv/case/open`,
                {
                    "case_id": cases.pop()["item"]["id"]
                }, {headers: {'Content-Type': 'application/json'}
                });
            if (response.data !== null){
                const prizeIndex = mappedPrizes.findIndex(
                    (item) => item.prize_type === response.data['prize_type'] && item.value === response.data['value']
                );

                if (prizeIndex !== -1) {
                    setPrizeNumber(prizeIndex);
                    setMustSpin(true);
                } else {
                    toast.error(t("The prize was not found in the wheel elements."));
                }
            }

        } catch (error) {
            console.log(error);
            toast.error(t("Could not spin the wheel."));
        }
    };

    const claimGiveaway = async () => {
        try {
            const response = await axiosInstance.post(`/festiveEvent/giveaway/claim`,
                {
                    "festive_event": festiveEventName
                }, {headers: {'Content-Type': 'application/json'}
                });
            if (response.data !== null){
                setClaimedGiveaway(response.data['claimed']); // Update the claimed status
                toast.success(t("Giveaway claimed!"));
            }

        } catch (error) {
            console.log(error);
            toast.error(t("Failed to claim giveaway."));
        }
    };


    return (
        <div className="container mt-4">
            <div className="card bg-secondary">
                <div className="card-body">
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="position-absolute opacity-25">
                            <svg xmlns="http://www.w3.org/2000/svg"  height="100%" width="100%" version="1.1" id="_x32_" viewBox="0 0 512 512">
                                <g>
                                    <polygon points="427.019,447.355 432.469,441.898 390.069,399.489 384.603,404.947  "/>
                                    <polygon points="427.482,65.01 385.081,107.411 390.531,112.893 432.947,70.468  "/>
                                    <path d="M510.355,252.228l-59.96-0.008v0.127c-12.954-3.178-32.872-31.199-46.607-62.74   c-12.684-18.412-22.77-66.509-14.93-74.914l1.673-1.8c-1.785-1.682-3.586-3.347-5.45-4.948l-2.023,2.183   c-7.84,8.445-29.654,12.676-68.771-1.96c-36.697-11.983-52.28-29.773-54.112-48.201V0h-7.728v59.967h0.558   c-0.192,0.016-0.374,0.025-0.558,0.033c-3.043,20.076-21.096,30.872-52.248,41.556c-28.235,12.293-62.613,17.017-70.444,8.572   l-0.606-0.653l0.271-0.263l-42.4-42.409l-5.466,5.466l42.401,42.408c7.855,8.421-6.94,57.769-12.278,68.564   c-21.822,39.7-41.094,66.047-50.949,68.309H1.645l0.008,8.23l59.602,0.008c10.994,4.796,33.429,31.541,46.957,62.565   c12.684,18.412,22.786,66.5,14.93,74.929l-0.876,0.941l-0.271-0.271L79.586,440.36l5.474,5.465l42.4-42.4l1.482-1.594   c7.84-8.453,29.654-12.668,68.772,1.952c36.664,11.975,52.239,29.741,54.104,48.145c0.645,0.024,1.282,0.056,1.92,0.104h-1.92V512   h7.719v-59.968c3.004-20.124,21.081-30.936,52.28-41.628c28.218-12.284,62.588-17.025,70.428-8.572l2.406,2.582   c1.848-1.594,3.633-3.267,5.417-4.924l-2.04-2.207c-7.839-8.429,6.948-57.768,12.302-68.572   c21.686-39.477,38.863-65.999,50.638-68.261h59.386V252.228z M261.474,92.106c3.306-4.031,22.578,17.48,49.586,26.45   c18.141,5.672,45.468,9.314,46.36,13.217c1.02,4.35-3.546,9.768-7.68,14.205l-1.498,1.618c-7.824,8.421-22.42,11.831-32.442,7.576   l-37.811-16.134c-10.022-4.262-18.189-17.893-18.189-30.274C259.801,103.715,259.171,94.903,261.474,92.106z M304.216,251.327   h-23.072c-10.636,0-12.939-6.883-5.099-15.32L287.9,223.26c7.84-8.437,18.612-6.493,23.933,4.286l2.063,4.175   C319.211,242.5,314.86,251.327,304.216,251.327z M313.06,280.263l-2.04,4.143c-2.462,4.987-4.908,11.624-8.875,12.676   c-4.613,1.235-10.851-3.848-15.05-8.381l-11.863-12.755c-7.856-8.421-5.562-15.313,5.091-15.313h23.08   C314.031,260.632,318.398,269.452,313.06,280.263z M281.718,191.822l-3.728-1.578c-10.022-4.278-18.189-17.926-18.189-30.339   c0-5.409-0.901-13.05,1.673-15.846c3.322-3.658,10.859-1.394,16.516,1.02l33.812,14.388c5.577,2.39,12.365,5.76,12.572,10.548   c0.159,3.808-5.186,8.82-8.636,12.54l-1.585,1.713C306.336,192.674,291.725,196.084,281.718,191.822z M261.051,195.048   c3.346-3.594,11.233-1.195,16.778,1.162c5.035,2.128,11.218,5.474,11.871,9.696c0.614,4.136-4.191,9.154-8.063,13.337l-7.585,8.134   c-7.839,8.436-14.252,5.131-14.252-7.33v-8.867C259.801,205.684,258.446,197.876,261.051,195.048z M273.225,284.573l7.585,8.158   c3.919,4.206,9.927,8.214,9.233,12.373c-0.693,4.174-8.054,8.541-13.01,10.652c-5.067,2.151-11.52,4.964-14.803,2.095   c-3.155-2.757-3.258-10.987-3.258-17.074v-8.867C258.972,279.443,265.385,276.144,273.225,284.573z M277.161,321.715l3.728-1.577   c5.004-2.135,12.54-5.545,18.42-4.175c5.896,1.386,10.095,7.545,14.022,11.751l1.562,1.689c7.856,8.421,6.079,18.81-3.92,23.065   l-33.812,14.42c-4.996,2.143-12.046,5.124-15.337,2.439c-3.29-2.693-2.852-11.05-2.852-17.273   C258.972,339.641,267.153,325.994,277.161,321.715z M319.259,323.285c-7.84-8.421-9.903-24.14-4.589-34.935l3.999-8.086   c5.314-10.811,18.388-19.631,29.024-19.631h7.816c10.644,0,14.994,8.82,9.664,19.631l-20.101,40.783   c-2.996,6.07-7.329,13.632-12.284,13.807c-3.84,0.151-8.215-5.84-11.648-9.52L319.259,323.285z M356.321,251.327h-7.816   c-10.652,0-23.702-8.827-29.039-19.606l-3.968-8.111c-5.338-10.779-3.274-26.514,4.557-34.944l1.912-2.055   c7.839-8.421,18.595-6.478,23.933,4.318l20.108,40.768C371.331,242.5,366.965,251.327,356.321,251.327z M167.009,122.89   l67.831-28.896c4.995-2.135,11.647-4.572,14.93-1.888c3.314,2.693,3.258,10.468,3.258,16.659c0,12.381-8.198,26.013-18.189,30.274   l-37.819,16.109c-10.015,4.279-24.61,0.869-32.442-7.568l-1.49-1.601C155.233,137.55,157.01,127.17,167.009,122.89z    M198.096,280.239c-5.314-10.787-0.956-19.606,9.688-19.606h23.072c10.636,0,12.93,6.892,5.099,15.313L224.1,288.7   c-7.839,8.437-18.619,6.493-23.933-4.294L198.096,280.239z M191.922,323.285l-1.872,2.04c-7.856,8.446-18.627,6.501-23.949-4.294   l-20.108-40.767c-5.314-10.811-0.956-19.631,9.688-19.631h7.816c10.636,0,23.702,8.82,29.015,19.606l4,8.111   C201.841,299.129,199.777,314.864,191.922,323.285z M231.677,251.327h-23.088c-10.62,0-14.986-8.827-9.664-19.63l2.047-4.151   c2.462-4.988,4.932-11.608,8.883-12.668c4.613-1.234,10.843,3.84,15.05,8.382l11.879,12.747   C244.607,244.444,242.313,251.327,231.677,251.327z M197.331,223.61l-3.991,8.087c-5.322,10.803-18.396,19.63-29.032,19.63h-7.824   c-10.636,0-14.978-8.827-9.656-19.63l20.101-40.784c2.996-6.062,7.346-13.632,12.293-13.814c3.832-0.128,8.198,5.84,11.632,9.512   l1.904,2.055C200.582,197.095,202.645,212.831,197.331,223.61z M94.796,231.697l38.13-77.344   c3.33-6.749,8.492-14.628,14.054-14.078c3.306,0.319,6.939,6.612,9.879,9.783l1.84,1.976c7.832,8.429,9.903,24.18,4.573,34.967   l-22.029,44.696c-5.322,10.803-18.404,19.63-29.039,19.63h-7.736C93.823,251.327,89.466,242.5,94.796,231.697z M132.113,357.599   l-38.138-77.336c-5.33-10.811-0.98-19.631,9.664-19.631h7.736c10.636,0,23.718,8.82,29.032,19.606l22.061,44.719   c5.322,10.803,3.25,26.538-4.597,34.952l-1.84,1.992C148.191,370.33,137.419,368.41,132.113,357.599z M250.535,419.853   c-3.33,4.039-22.571-17.455-49.595-26.45c-18.14-5.656-45.467-9.314-46.36-13.217c-1.003-4.342,3.546-9.767,7.68-14.205   l1.482-1.617c7.839-8.406,22.435-11.831,32.449-7.576l37.835,16.133c9.991,4.262,18.165,17.894,18.165,30.267   C252.192,408.254,252.829,417.057,250.535,419.853z M250.535,367.916c-3.354,3.641-10.867,1.386-16.508-1.028l-33.828-14.396   c-5.577-2.398-12.349-5.752-12.572-10.548c-0.159-3.792,5.194-8.835,8.652-12.54l1.57-1.712   c7.832-8.422,22.427-11.831,32.434-7.553l3.744,1.593c9.991,4.262,18.165,17.91,18.165,30.322   C252.192,357.439,253.108,365.104,250.535,367.916z M250.949,316.912c-3.346,3.585-11.233,1.195-16.803-1.155   c-4.995-2.151-11.193-5.482-11.846-9.704c-0.622-4.135,4.191-9.154,8.063-13.321l7.584-8.158c7.84-8.429,14.245-5.13,14.245,7.338   v8.867C252.192,306.268,253.554,314.083,250.949,316.912z M253.029,220.048c0,12.461-6.422,15.766-14.253,7.33l-7.585-8.151   c-3.919-4.198-9.919-8.214-9.226-12.373c0.677-4.174,8.055-8.524,13.002-10.644c5.067-2.159,11.52-4.971,14.803-2.11   c3.138,2.748,3.258,10.986,3.258,17.081V220.048z M253.029,159.905c0,12.413-8.198,26.06-18.189,30.339l-3.76,1.578   c-4.972,2.135-12.508,5.529-18.404,4.175c-5.872-1.386-10.094-7.529-14.022-11.744l-1.546-1.697   c-7.839-8.429-6.078-18.818,3.912-23.072l33.82-14.404c4.995-2.143,12.038-5.131,15.352-2.454   C253.483,145.326,253.029,153.707,253.029,159.905z M344.992,389.052l-67.831,28.913c-4.996,2.135-11.64,4.572-14.93,1.888   c-3.29-2.685-3.258-10.46-3.258-16.666c0-12.373,8.182-26.004,18.189-30.267l37.812-16.109c10.022-4.278,24.61-0.853,32.449,7.568   l1.49,1.601C356.767,374.409,354.99,384.799,344.992,389.052z M417.205,280.263l-38.13,77.336   c-3.315,6.748-8.493,14.635-14.038,14.085c-3.33-0.318-6.956-6.612-9.895-9.783l-1.848-1.992   c-7.831-8.414-9.895-24.148-4.573-34.952l22.052-44.695c5.306-10.811,18.388-19.631,29.016-19.631h7.744   C418.192,260.632,422.527,269.452,417.205,280.263z M408.377,251.327h-7.76c-10.644,0-23.709-8.827-29.032-19.606l-22.036-44.719   c-5.338-10.787-3.283-26.538,4.573-34.967l1.849-1.976c7.839-8.429,18.595-6.508,23.933,4.295l38.114,77.344   C423.355,242.5,418.989,251.327,408.377,251.327z"/>
                                </g>
                            </svg>
                        </div>
                        <div className="position-absolute w-25">
                            <img className="w-100" src="/pum.gif"/>
                        </div>

                        <Wheel
                            mustStartSpinning={mustSpin}
                            prizeNumber={prizeNumber}
                            data={segments}
                            backgroundColors={['#3e3e3e', '#df3428']}
                            textColors={['#ffffff']}
                            outerBorderWidth={0}
                            radiusLineWidth={0}
                            innerRadius={50}
                            spinDuration={Math.floor(Math.random() * 1) + 0.5}
                            onStopSpinning={() => {
                                setMustSpin(false);
                                const prize =  mappedPrizes[prizeNumber]
                                console.log(prize)
                                switch (prize.prize_type){
                                    case "item":
                                        toast.success(t("You win")+" " +t(prize.itemData.name));
                                        break;
                                    case "coins":
                                        toast.success(t("You win")+" " +prize.value + " " + t(prize.prize_type));
                                        break;
                                    default:
                                        toast.success(t("You win")+" something");
                                }
                            }}
                        />
                    </div>
                    <div className="text-center">{t("Attempts")}: {cases.length}</div>
                    {timeLeft.current > 0 && (
                        <div className="text-center mt-2">
                            <p>{t("Next hand in")}: {formatTimeLeft(timeLeft.current)}</p>
                        </div>
                    )}
                    {canClaimGiveaway ? (
                        <div className="d-flex justify-content-center mt-3">
                           <button className={`btn btn-primary ${mustSpin ? "disabled" : ""}`}  onClick={claimGiveaway}>{t("Claim Giveaway")}</button>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center mt-3">
                            {
                                cases.length > 0 ? (
                                    <button className={`btn btn-primary ${mustSpin ? "disabled" : ""}`}  onClick={spin}>{t("Candy or Death")}</button>
                                ) : (
                                    <button className={"btn btn-primary"} onClick={handleBuyClick}>{t("Buy")}</button>
                                )
                            }
                        </div>
                    )}
                </div>
            </div>
            <div>
                {mappedPrizes && [...mappedPrizes]
                    .sort((a, b) => {
                        const typeOrderDiff = (customOrder[a.prize_type] || Infinity) - (customOrder[b.prize_type] || Infinity);
                        return typeOrderDiff !== 0 ? typeOrderDiff : b.chance - a.chance;
                    })
                    .map(e => (
                        <div className="mt-2 bg-secondary p-1 d-flex align-items-center rounded-1" key={e.id}>
                            <div style={{ width: "1em", height: "1em", background: e.color }} className="m-1 rounded-1"></div>
                            {(() => {
                                switch (e.prize_type) {
                                    case 'coins':
                                        return <span>{e.value} {t(e.prize_type)}</span>;
                                    case 'item':
                                        return <span>{t(e.itemData.name)}</span>;
                                    default:
                                        return <span>{t(e.prize_type)}</span>;
                                }
                            })()}
                        </div>
                    ))}
            </div>
            <BuyItem isOpen={isBuyOpen} itemName={itemToBuy} onClose={handleCloseBuyItem} />
        </div>
    );
};

export default SpinWheel;
